export default __webpack_public_path__ + "b2147b57ae40aac00cbdd93b51b9fd89.png";